import { Image, Link, StyleSheet, Text, View } from "@react-pdf/renderer";
import { extractUploadFileName, GOAL_TRACK_PARAMETERS, GOAL_TRACK_PARAMETERS_COLORS_V2, GOAL_TRACK_PARAMETERS_V2 } from "config/constants";
import { globalStyles } from "config/pdfStyles";
import { getGoalTrackingCount, getGoalTrackingPercentage } from "helpers/assessment";
import attachments_img from "Assets/images/AttachmentIcon.png"
import Html from "react-pdf-html";
import graphSliderImg from "../../../../../Assets/images/graphSliderImg.png"
import moment from "moment";
import PDFHtmlRenderer from "./PDFHtmlRenderer";
import { useParams } from "react-router-dom";

const ObservationsSection = ({ data, therapistDetails, showChart = false, clientType = "", chartImages = [], fontSize = 9, styles, type = "Observation" }) => {
  return (
    <>
      {data?.length > 0 && data?.map((item, index) => {
        // const attachments = goal?.goal_attachementData ? JSON.parse(goal?.goal_attachementData) : [];
        return (
          <>
            <View>
              <View style={{ width: "100%", marginTop: 4, marginBottom: 6,  }}>
                <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>{type.toUpperCase()} {index + 1}: <Text style={{ fontWeight: "light" }}>{item?.obs_date ? moment(item?.obs_date).format("MMMM DD, YYYY") : ""}</Text> </Text>
              </View>
              {
                ["school", "private", "home-education", "home_education"]?.includes(clientType) &&  <View style={{ width: "100%", marginTop: 4, marginBottom: 6, }}>
                <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", borderBottom: "0.50px solid #000", }}>AREA: <Text style={{ fontWeight: "light" }}>{item?.area_id?.label || ""}</Text> </Text>
              </View>
              }
              <View style={{ ...styles.flex, gap: "12px" }}>
                <View style={{ width: "60%" }}>
                  <View style={{ marginTop: data?.[index]?.show_tracker != "hidden" && "10px" }}>
                    {chartImages?.length && data?.[index]?.show_tracker != "hidden" && (
                      <Image src={chartImages[index]} />
                    )}
                  </View>
                </View>
              </View>
              <Text style={{ ...styles?.para, marginTop: "5px", marginBottom: "10px", fontSize, lineHeight: "13px" }}>
                {item?.notes}
              </Text>
            </View>
            <View style={{ width: "100%", }}>
              {
                item?.strategy?.map((strategy, strategyIndex) =>
                  <View>
                    <Text style={{ ...styles.mainSubHeading, paddingBottom: "2px", marginBottom: 6, borderBottom: "0.50px solid #000", }}>STRATEGY {strategyIndex + 1}</Text>
                    <View style={{ marginTop: 4, marginBottom: 6, paddingBottom: 8 }}>
                      <PDFHtmlRenderer
                        style={{ ...styles?.para, fontSize }}
                        data={strategy?.answers}
                      />
                      {strategy?.attachmentData?.length && (
                        <View style={{ marginBottom: "10px" }}>
                          {strategy?.attachmentData?.map((item, index) => (
                            <View style={{ ...styles.flex, marginTop: '7px' }}>
                              <Link
                                key={index}
                                src={item?.attachment_name}
                                style={{ ...styles.fontSemibold, ...styles.subHeading, color: "#000" }}
                              >
                                {extractUploadFileName(item?.attachment_name)}
                              </Link>
                            </View>
                          ))}
                        </View>
                      )}
                    </View>
                  </View>
                )
              }
            </View>
          </>
        )
      })}
    </>
  )
}


export default ObservationsSection;